module.exports = __webpack_public_path__ + "img/google-share.05da1fe.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/google-share.svg
// module id = ni/J
// module chunks = 13